"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.olapicCategoryItem = void 0;
var _zod = require("zod");
/* eslint-disable @typescript-eslint/naming-convention -- external */

const olapicCategoryItem = exports.olapicCategoryItem = _zod.z.object({
  id: _zod.z.string(),
  name: _zod.z.string()
});
